import { StyleRules } from '@material-ui/core/styles';
import { StepIconClasskey } from '@material-ui/core/StepIcon';

import { core as theme } from '../styles/core';

export const MuiStepIcon: Partial<StyleRules<StepIconClasskey>> = {
  root: {
    color: theme.palette.grey[500],
    width: '1.5rem',
    height: '1.5rem',
  },
  text: {
    fill: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightMedium,
  },
};
